import Backbone from "backbone";
interface IExpandableItem {
    id: string;
    title: string;
    content: any;
    expanded?: boolean;
}

export class ExpandableItem extends Backbone.Model {

    // eslint-disable-next-line @typescript-eslint/no-useless-constructor
    constructor (attributes: IExpandableItem, options?) {
        super(attributes, options);
    }

    defaults () {
        return {
            expanded: false
        };
    }

    // No sync
    sync () {
        return false;
    }

    //Toggle the expand state of this item.
    toggle (state?: boolean) {
        let currentState: boolean = this.get("expanded");
        let newState = typeof (state) !== "undefined" ? state : !currentState;
        this.set({ expanded: newState });
    }

    clear () {
        this.destroy();
    }
}